import { SVGProps } from 'react';

export function TennisBall({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Tennis ball seam curves */}
      <path d="M 6 4 C 8 8, 8 16, 6 20" />
      <path d="M 18 4 C 16 8, 16 16, 18 20" />
    </svg>
  );
}
